module.exports = __webpack_public_path__ + "arrow-prev@2x.png?511b2bcaf1ebaf57c9c7e8066b489ff7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-prev@2x.png
// module id = 24
// module chunks = 0